import React, { Component } from 'react'
import { Route, NavLink, HashRouter } from "react-router-dom";
import moment from 'moment'
import Pagination from '../../pagination'
import history from '../../redux/routerHistory'
import { configs } from '../../helpers/constants'
import $ from "jquery"
import { get, post } from '../../utils/networking'
import LinesEllipsis from 'react-lines-ellipsis'
const _take = 10

export class ListBlogs extends Component {

    constructor(props) {
        super(props)
        this.state = {
            page: 1,
            nextPage: 1,
            pageTitle: 'Wait...',
            blogs: [],
            total: 0
        }
    }

    componentDidMount() {
        const page = this.props.match.params.page ? this.props.match.params.page : 1
        const skip = page * _take - _take

        let param = {
            skip: skip,
            take: _take,
            slug: this.props.match.params.slug
        }
        this.getListBlogs(param);
        var sub = $('.menu_blog .accordion_show');
        sub.hide();
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.match.params.slug === this.props.match.params.slug)
            return
        const page = nextProps.match.params.page ? this.props.match.params.page : 1
        const skip = page * _take - _take

        let param = {
            skip: skip,
            take: _take,
            slug: nextProps.match.params.slug
        }
        this.getListBlogs(param);
    }

    getListBlogs(param) {
        const page = param.skip / param.take + 1
        post('blog/get', param, "", result => {
            this.setState({
                page: page,
                blogs: result.items,
                pageTitle: ""
            })
        })
    }

    handlePageChange(page) {

        const slug = this.props.match.params.slug

        if (slug)
            history.push("/blog/category/" + slug + "/" + page)
        else
            history.push("/blogs/" + page)

        const skip = page * _take - _take

        let param = {
            skip: skip,
            take: _take,
            slug: slug
        }

        this.getListBlogs(param);

    }
    signupClick() {
        const mail = this.refs.mail.value;
        var regExp = new RegExp("[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}$")
        if (!regExp.test(mail))
            return

        get('user/subscribe/' + encodeURIComponent(mail), "customer", result => {
            alert("Subcribe success")
        }, errors => {
            alert("Subcribe fail")
        })
    }
    headerBlog(e) {
        e.preventDefault();
        var sub = $('.menu_blog .accordion_show');
        var click_open = $('.tagline p.click_open');
        var icon = $('.tagline i.fa');
        icon.addClass('fa-angle-down');
        if (sub.is(':visible')) {
            $(click_open).removeClass('open');
            $(click_open).addClass('close');
            $(icon).removeClass('fa-angle-up');
            $(icon).addClass('fa-angle-down');
            sub.slideUp();
        } else {
            $(click_open).removeClass('close');
            $(click_open).addClass('open');
            $(icon).removeClass('fa-angle-down');
            $(icon).addClass('fa-angle-up');
            sub.slideDown();
        }
    }

    render() {
        $("html, body").animate({ scrollTop: 0 }, 400);
        let { page, blogs, pageTitle, categories, total } = this.state
        return (
            <div>
                <main>
                    <div className="border_line_bottom">
                        <div className="container">
                            <div className="content clearfix page_blog">
                                <div className="content_main clearfix">
                                    <div className="header_blog">
                                        <div className="clearfix">
                                            <div className="logo_blog">
                                                <span>BLOG</span>
                                            </div>
                                            <div className="tagline">
                                                <p>Your guide to living well, all year long!</p>
                                                <p className="categories click_open close" onClick={this.headerBlog}>CATEGORIES <i className="fa fa-angle-down"></i></p>
                                            </div>
                                        </div>
                                        <div className="menu_blog" >
                                            <div className="clearfix">
                                                <ul className="clearfix accordion_show">
                                                    {categories && categories[0] && categories[0].categories.map((item, index) =>
                                                        <li key={index} ><NavLink to={"/blog/category/" + item.slug} onClick={() => $('.menu_blog .accordion_show').hide()}>{item.name}</NavLink></li>
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="clearfix">
                                        <div className="left col_8 col_sm_12">
                                            <div className="border_right">
                                                <div className="querytotalhitscount">
                                                    <h3 className="title_page">{pageTitle}</h3>
                                                </div>
                                                <div className="list_blog">
                                                    {blogs.map((blog, i) =>
                                                        <div className="product_blog clearfix" key={i}>
                                                            <div className="col_5 col_sm_12">
                                                                <div className="img">
                                                                    <NavLink to={"/blog/" + blog.slug}>
                                                                        <img src={configs.api_domain + blog.photo} alt="" />
                                                                    </NavLink>
                                                                </div>
                                                            </div>
                                                            <div className="article col_7">
                                                                <div>
                                                                    <NavLink to={"/blog/category/" + blog.category.slug} className="blog-name">
                                                                        {blog.category.name}
                                                                    </NavLink>
                                                                    <address> by Nail spa of america | {moment(blog.publicDate).format("MMMM DD, YYYY")}</address>
                                                                    <h2 style={{ lineHeight: "1em" }}>
                                                                        <NavLink className="b-link" to={"/blog/" + blog.slug} style={{ fontSize: "18px" }}>
                                                                            <LinesEllipsis className="link_ellipsic"
                                                                                text={blog.title}
                                                                                maxLine='2'
                                                                                ellipsis='...'
                                                                                trimRight
                                                                                basedOn='letters'
                                                                            />
                                                                        </NavLink>
                                                                    </h2>
                                                                    <LinesEllipsis className="text_ellipsic"
                                                                        text={blog.synopsis}
                                                                        maxLine='4'
                                                                        ellipsis='...'
                                                                        trimRight
                                                                        basedOn='letters'
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    <Pagination
                                                        total={total}
                                                        pageSize={_take}
                                                        currentPage={page}
                                                        onPageChange={this.handlePageChange.bind(this)}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="right col_4 col_sm_12">
                                            <div id="ct_map" className="clearfix">
                                                <section>
                                                    <form>
                                                        <div className="content-form clearfix">
                                                            <input type="text" name="s" placeholder="Search Articles" className="input_text" />
                                                            <input type="submit" className="input_submit" value="Search" />
                                                        </div>
                                                    </form>
                                                </section>
                                                <section>
                                                    <h3 className="gform_title">Newsletter subscription</h3>
                                                    <p>Get instant access to weekly tips and tricks for living well, plus exclusive offers and updates from Nail spa of america!</p>
                                                    <form>
                                                        <div className="content-form clearfix">
                                                            <input type="text" name="s" placeholder="Enter Email Address" className="input_text" ref="mail" />
                                                            <span className="input_submit" onClick={() => this.signupClick()} >Subcribe</span>
                                                        </div>
                                                    </form>
                                                </section>
                                                <section>
                                                    <div className="b-follow">
                                                        <NavLink to="#" className="b-follow__link b-follow__fb"></NavLink>
                                                        <NavLink to="#" className="b-follow__link b-follow__tw"></NavLink>
                                                        <NavLink to="#" className="b-follow__link b-follow__instgr"></NavLink>
                                                        <NavLink to="#" className="b-follow__link b-follow__pin"></NavLink>
                                                        <NavLink to="#" className="b-follow__link b-follow__yt"></NavLink>
                                                    </div>
                                                </section>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        )
    }
}
export default ListBlogs


// WEBPACK FOOTER //
// ./src/components/listBlogs/index.js